'use strict';

export function getLifeInsuranceSubscriptionAlert(onSuccess, onFailed) {
    const route = API_ENDPOINT + 'afficher-alerte-assurance-vie';
    const xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function () {
        if (this.readyState !== 4) return;

        if (this.status === 200) {
            const response = JSON.parse(this.responseText);
            onSuccess(response);
        } else {
            onFailed();
        }
    };

    xmlhttp.open('POST', route, true);
    xmlhttp.setRequestHeader('Content-Type', 'application/json');
    xmlhttp.send(null);
}
